<template>
  <div class="flex pt-10">
    <form class="w-1/2 max-w-lg" @submit.prevent="editAddress">
      <div class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <label
            class="block tracking-wide text-gray-700 text-xs font-semibold mb-2"
            for="grid-type"
          >{{ $t('Type')}}</label>
          <div class="relative">
            <select
              class="outline-none block appearance-none w-full border text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:border-teal-400"
              id="grid-type"
              v-model="address.type"
            >
              <option>Shipping</option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <label
            class="block tracking-wide text-gray-700 text-xs font-semibold mb-2"
            for="grid-address-1"
          >{{ $t('Address1')}}</label>
          <input
            class="outline-none appearance-none block w-full text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:border-teal-400"
            id="grid-address-1"
            type="text"
            v-model="address.address_1"
          />
        </div>
        <div class="w-full px-3">
          <label
            class="block tracking-wide text-gray-700 text-xs font-semibold mb-2"
            for="grid-address-2"
          >{{ $t('Address2')}}</label>
          <input
            class="outline-none appearance-none block w-full text-gray-700 border rounded py-3 px-4 leading-tight focus:border-teal-400"
            id="address-2"
            type="text"
            v-model="address.address_2"
          />
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <label
            class="block tracking-wide text-gray-700 text-xs font-semibold mb-2"
            for="grid-city"
          >{{ $t('City')}}</label>
          <input
            class="outline-none appearance-none block w-full text-gray-700 border rounded py-3 px-4 leading-tight focus:border-teal-400"
            id="grid-city"
            type="text"
            v-model="address.city"
          />
        </div>
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <label
            class="block tracking-wide text-gray-700 text-xs font-semibold mb-2"
            for="grid-country"
          >{{ $t('Country')}}</label>
          <div class="relative">
            <select
              class="outline-none block appearance-none w-full border text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:border-teal-400"
              id="grid-country"
              v-model="address.country"
            >
              <option>Deutschland</option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <label
            class="block tracking-wide text-gray-700 text-xs font-semibold mb-2"
            for="grid-zip"
          >{{ $t('Zip')}}</label>
          <input
            class="outline-none appearance-none block w-full text-gray-700 border rounded py-3 px-4 leading-tight focus:border-teal-400"
            id="grid-zip"
            type="number"
            v-model="address.zip"
          />
        </div>
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 mt-2">
          <input type="checkbox" class="mt-1" v-model="address.isDefault" @change="setDefault" />
          <label
            class="tracking-wide text-gray-700 text-xs font-semibold mb-2 ml-2"
          >{{$t('SetDefaultAddress')}}</label>
        </div>
      </div>
      <div class="p-3">
        <router-link to="/profile" class="mr-3 px-4 py-2 text-teal-400">{{ $t('Back')}}</router-link>
        <button
          type="submit"
          class="bg-teal-400 px-4 py-2 rounded text-white hover:bg-white hover:text-teal-400"
        >{{ $t('Update')}}</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      address: {},
      id: this.$route.params.id
    };
  },
  created() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("access_token");

    axios
      .get(`${process.env.VUE_APP_API}/address/${this.id}`)
      .then(response => {
        this.address = response.data.data;
      });
  },
  methods: {
    setDefault() {
      this.isDefault = true;
      console.log(this.isDefault);
    },
    editAddress() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .put(`${process.env.VUE_APP_API}/address/${this.id}`, {
          type: this.address.type,
          address_1: this.address.address_1,
          address_2: this.address.address_2,
          city: this.address.city,
          state: this.address.state,
          country: this.address.country,
          zip: this.address.zip,
          isDefault: this.address.isDefault
        })
        .then(this.$router.back())
        .then(
          this.$notify({
            group: "address",
            title: "Address",
            text: "Adresse wurde aktualisiert"
          })
        )
        .catch(error => console.log(error));
    }
  }
};
</script>

<style>
</style>